import classNames from "classnames";
import styles from "./LiveTileOverlay.module.less";
import { AppImageDisplayInfo, RenderImageType } from "client/Api/AppIcon/common";
import { ReactElement } from "react";
import { AppIcon } from "client/Components";
import { setTrackingId } from "client/Misc/utils";

export type LiveTileOverlayProps = {
	icon: AppImageDisplayInfo;
	name: string;
	isDisabled: boolean;
	hasOneCellHeight: boolean;
	tooltip: string;
};

export const LiveTileOverlay = (props: LiveTileOverlayProps): ReactElement => {
	const {
		icon,
		isDisabled,
		name,
		hasOneCellHeight,
		tooltip
	} = props;

	const isColorizableSvg: boolean = icon.renderType === RenderImageType.ColorizableSvg;

	return (
		<div
			className={classNames(
				styles.root,
				{
					[styles.root_disabled]: isDisabled,
					[styles.root_height1]: hasOneCellHeight
				}
			)}
			title={tooltip}
		>
			<div
				className={classNames(
					styles.icon,
					{ [styles.icon_nonColorizable]: !isColorizableSvg }
				)}
			>
				<AppIcon value={icon} color="inherit" />
			</div>
			<div className={styles.footer}>
				<h4
					{...setTrackingId("name")}
					className={styles.name}
				>
					{ name }
				</h4>
			</div>
		</div>
	);
};
LiveTileOverlay.displayName = "LiveTileOverlay";